import React from 'react';
import { Upload, Calendar, Send, Check } from 'lucide-react';
import '../styles/HomePage.css';

function HomePage({ onLogin, onRegister }) {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header">
        <div className="landing-container">
          <div className="landing-header-content">
            <div className="landing-header-left">
              <h1 className="landing-logo">Certifiable</h1>
              <span className="beta-badge">FREE BETA</span>
            </div>
            <div className="landing-header-actions">
              <button onClick={onLogin} className="btn-landing-signin">
                Sign In
              </button>
              <button onClick={onRegister} className="btn-landing-signup">
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="landing-container">
          <div className="hero-content">
            <h2 className="hero-title">
              Never lose track of your certificates again
            </h2>
            <p className="hero-subtitle">
              Keep your certifications organized, up-to-date, and ready to share when you need them.
            </p>
            <div className="hero-cta">
              <button onClick={onRegister} className="btn-hero-primary">
                Start Free Beta
              </button>
            </div>
            <p className="hero-trust">
              <span className="trust-item"><Check size={16} /> Free during beta</span>
              <span className="trust-item"><Check size={16} /> Unlimited certificates</span>
              <span className="trust-item"><Check size={16} /> No credit card required</span>
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="landing-container">
          <h3 className="section-title">Everything you need to stay compliant</h3>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><Upload size={40} strokeWidth={1.5} /></div>
              <h4 className="feature-title">Easy Upload</h4>
              <p className="feature-text">
                Take a photo or upload your certificate. Add details. Done in seconds.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><Calendar size={40} strokeWidth={1.5} /></div>
              <h4 className="feature-title">Track Expiry Dates</h4>
              <p className="feature-text">
                See which certificates expire soon. Never miss a renewal deadline.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon"><Send size={40} strokeWidth={1.5} /></div>
              <h4 className="feature-title">Share Instantly</h4>
              <p className="feature-text">
                Email certificates to employers with secure download links. No more chasing paperwork.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="landing-container">
          <div className="cta-content">
            <h3 className="cta-title">Ready to get organized?</h3>
            <p className="cta-text">
              Join workers who trust Certifiable to keep their credentials organized and accessible.
            </p>
            <button onClick={onRegister} className="btn-cta">
              Join Free Beta
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-container">
          <div className="footer-content">
            <div className="footer-left">
              <p className="footer-text">
                © 2025 Certifiable by Novakind
              </p>
            </div>
            <div className="footer-right">
              <a href="/privacy" className="footer-link">Privacy Policy</a>
              <span className="footer-divider">·</span>
              <a href="/terms" className="footer-link">Terms of Service</a>
              <span className="footer-divider">·</span>
              <a href="mailto:romijade@gmail.com" className="footer-link">romijade@gmail.com</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;
